export interface JobSiteSelectorProps {
  handleChange: (jobSite: string) => void;
  customStyle?: any;
  handleJobSiteName?: (jobSiteName: string) => void;
}

export const SelectedAllOptions = 'all';
